import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';

import { QueryClient, QueryClientProvider } from "react-query";
import {BrowserRouter} from 'react-router-dom';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles'

import {MDBSpinner} from "mdbreact";

import ToastContext from "./context/ToastContext";
import Swal from 'sweetalert2';

import '@fortawesome/fontawesome-pro/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css'

import './index.css';

import App from './App';

const theme = createMuiTheme({
    palette: {
        primary: {
            contrastText: "#fff",
            main: "#0f3f62",
            light: "#f7fafc"
        },
    },
})
const toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
    didOpen: (toastElement) => {
        toastElement.addEventListener('mouseenter', Swal.stopTimer)
        toastElement.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

const queryClient = new QueryClient()

ReactDOM.render(
    <QueryClientProvider client={queryClient}>
        <Suspense fallback={<MDBSpinner/>}>
            <BrowserRouter>
                <ThemeProvider theme={theme}>
                    <ToastContext.Provider value={{toast: toast}}>
                        <App/>
                    </ToastContext.Provider>
                </ThemeProvider>
            </BrowserRouter>
        </Suspense>
    </QueryClientProvider>,
    document.getElementById('root')
);
